<template>
  <div class="row">
    <div class="col-xs-12 col-sm-5">
      <a
        href="#"
        @click.prevent="showShareModal=true"
      >
        <img
          :src="product.ThumbURL"
          :alt="getMotionProductContent('checkout-download-motion-product-thumbnail-hover-tooltip').Content"
          :title="getMotionProductContent('checkout-download-motion-product-thumbnail-hover-tooltip').Content"
          class="motion-product__thumb-img"
        >
      </a>
    </div>

    <div
      class="col-xs-12 col-sm-7"
    >
      <div>
        <div class="motion-product__lede">
          <contentful-text :item="getMotionProductContent('checkout-download-motion-product-lede')" />
        </div>
        <div class="motion-product__expiration-notice">
          <strong>
            <contentful-text :item="getMotionProductContent('checkout-download-motion-product-expiration-notice')" />
          </strong>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-5">
            <a
              href="#"
              class="button motion-product__view-share-button"
              @click.prevent="handleViewShareButtonClick"
            >
              <contentful-text :item="getMotionProductContent('checkout-download-motion-product-show-modal-button-label')" />
            </a>
          </div>
          <div class="col-xs-12 col-md-7">
            <a
              :href="product.VideoURL"
              class="button motion-product__download-button"
              download
              target="_blank"
            >
              <contentful-text :item="getMotionProductContent('checkout-download-motion-product-download-button-label')" />
            </a>
          </div>
        </div>
        <div
          v-if="false"
          class="motion-product__download-instructions"
        >
          <contentful-text :item="getMotionProductContent('checkout-download-motion-product-download-instructions')" />
        </div>
      </div>
    </div>
    <motion-product-modal
      :product="product"
      :show="showShareModal"
      @modal-close="showShareModal = false"
    />
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'
import MotionProductModal from './MotionProductModal'
import motionProductMixin from './mixin'

export default {
  name: 'MotionProduct',
  components: {
    MotionProductModal
  },
  mixins: [
    motionProductMixin
  ],
  props: {
    product: { type: Object, default: null, required: true }
  },
  data () {
    return {
      showShareModal: false
    }
  },
  computed: {
    content () {
      return this.$store.state.viewModel.PageContent
    }
  },
  methods: {
    handleViewShareButtonClick () {
      this.showShareModal = true

      GoogleAnalytics.trackEvent(
        'Personalized Ceremony Video',
        'click',
        'View & Share'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.motion-product {
  &__lede {
    font-size: 16px;
    margin: 0 0 20px 0;
    text-align: center;
  }

  &__thumb-img {
    margin-bottom: 20px;
    width: 100%;
  }

  &__view-share-button {
    background-color: #fff;
    border: 2px solid $grad-color-blue;
    color: $grad-color-blue;
    font-size: 20px;
    font-weight: bold;
    line-height: 2.5;
    margin: 0 0 20px 0;
    text-align: center;
    width: 100%;
  }

  &__download-button {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    width: 100%;
  }

  &__download-instructions {
    color: #333;
    margin-top: 7px;
    padding: 12px;
    background-color: #eee;
    font-size: 10px;
  }

  &__expiration-notice {
    font-size: 22px;
    line-height: 1.5;
    margin-bottom: 20px;
    text-align: center;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__lede {
      text-align: left;
    }

    &__expiration-notice {
      font-size: 16px;
      text-align: left;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &__thumb-img {
      width: 385px;
    }

    &__view-share-button {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/MotionProduct/MotionProduct.vue